// Jendela edit bulanan Admin Prodi/Admin Koas: tanggal selesai 31 = "Akhir bulan"
// (hari efektif = min(nilai, jumlah hari bulan itu); cermin backend/periode_edit.py).
export const AKHIR_BULAN = 31;
export const TANGGAL_MULAI_MAKS = 28;

const HARI_BIASA = Array.from({ length: 28 }, (_, i) => i + 1);

// Nilai yang ditawarkan di pilihan "Tanggal Selesai": 1-28 + Akhir bulan (31).
// Nilai tersimpan di luar daftar (mis. 29/30) tetap ditampilkan agar tidak hilang diam-diam.
export function opsiTanggalSelesai(tersimpan) {
    const nilai = Number(tersimpan);
    const ekstra = nilai > 28 && nilai < AKHIR_BULAN ? [nilai] : [];
    return [...HARI_BIASA, ...ekstra, AKHIR_BULAN];
}

export function labelTanggalSelesai(nilai) {
    return Number(nilai) >= AKHIR_BULAN ? "Akhir bulan" : String(nilai);
}

export function hariAkhirEfektif(tanggalSelesai, tahun, bulan1sd12) {
    const jumlahHari = new Date(tahun, bulan1sd12, 0).getDate();
    return Math.min(Number(tanggalSelesai), jumlahHari);
}

// Teks rentang untuk layar. `efektif` dari server (tanggal_selesai_efektif); bila tidak ada, pakai nilai tersimpan.
export function teksRentangPeriode(periode) {
    const efektif = periode?.tanggal_selesai_efektif ?? periode?.tanggal_selesai;
    return `${periode?.tanggal_mulai}–${efektif}`;
}
